module.exports = __webpack_public_path__ + "media/images/logos/app-logo-navy-1000px-5624d57a5d1d4ea708565ec1dfca45b7.png";